import {
    FIRMWARE_ASSIGN_OPEN_MODAL,
    FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST,
    FIRMWARE_ASSIGN_GET_FIRMWARE_RESULT,
    FIRMWARE_ASSIGN_GET_DEVICE_REQUEST,
    FIRMWARE_ASSIGN_GET_DEVICE_RESULT,
    FIRMWARE_ASSIGN_FIRMWARE_REQUEST,
    FIRMWARE_ASSIGN_FIRMWARE_RESULT,
    FIRMWARE_ASSIGN_SET_DEVICES,
} from 'Redux/actionTypes';

export const firmwareAssignSetDevices = (data) => ({
    type: FIRMWARE_ASSIGN_SET_DEVICES,
    payload: data
})

export const firmwareAssignOpenModal = (data) => ({
    type: FIRMWARE_ASSIGN_OPEN_MODAL,
    payload: data
})

export const firmwareAssignGetFirmwareRequest = (data) => ({
    type: FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST,
    payload: data
})

export const firmwareAssignGetFirmwareResult = (data) => ({
    type: FIRMWARE_ASSIGN_GET_FIRMWARE_RESULT,
    payload: data
})

export const firmwareAssignGetDeviceRequest = (data) => ({
    type: FIRMWARE_ASSIGN_GET_DEVICE_REQUEST,
    payload: data
})

export const firmwareAssignGetDeviceResult = (data) => ({
    type: FIRMWARE_ASSIGN_GET_DEVICE_RESULT,
    payload: data
})

export const firmwareAssignFirmwareRequest = (data) => ({
    type: FIRMWARE_ASSIGN_FIRMWARE_REQUEST,
    payload: data
})

export const firmwareAssignFirmwareResult = (data) => ({
    type: FIRMWARE_ASSIGN_FIRMWARE_RESULT,
    payload: data
})